<div class="dialog-header">
    <div style="font-size: 1.5rem;font-weight: 400;margin-bottom: 2%;"> Purchase Order Archive</div>
    <button mat-dialog-close class="close-button">
        <mat-icon>close</mat-icon>
    </button>
</div>
<div class="dialog-content">

    <div *ngIf="archive_data && archive_data.length > 0 else noDataContent">
        <div class="card">
            <div class="card-body table-responsive">
                <table class="table table-hover">
                    <thead class="text-warning">
                        <th>Sl No</th>
                        <th>Po No</th>
                        <!-- <th>Quotation Nos</th> -->
                        <th>Requisition Nos</th>
                        <th>Vendor Name</th>
                        <th>Vendor Branch Name</th>
                        <th>Document Type</th>
                        <th>Contact Name</th>
                        <th>Store Name</th>
                         <th>Type</th>
                        <th>Date</th>
                        <th></th>
                    </thead>
                    <tbody>
                        <ng-container *ngFor="let item of archive_data; let i = index">
                            <tr (click)="item.expanded = !item.expanded" (click)="poDetails(item.id)">
                                <td>{{ i + 1 }}</td>
                                <td>{{ item.po_no }}</td>
                                <!-- <td>
                                                <span *ngFor="let quotation of item.quotationcomparision; let i = index">
                                                {{ quotation.qc_no }}<span *ngIf="i < item.quotationcomparision.length - 1">, </span>
                                                </span>
                                            </td> -->
                                <td>
                                    <span *ngFor="let requistions of item.requistion; let i = index">
                                        {{ requistions.req_no }}<span *ngIf="i < item.requistion.length - 1">, </span>
                                    </span>
                                </td>
                                <td>{{ item?.vendor?.vendor_name }}</td>
                                <td>{{ item?.vendor_branch?.branch_name }}</td>
                                <td>{{ item?.document_type }}</td>
                                <td>{{ item?.contact?.name }}</td>
                                <td>{{ item?.store?.store_name }}</td>
                                 <td>{{ item?.type }}</td>
                                <td>{{ item?.date }}</td> 
                                <td class="action-iconbox">
                                    <ng-container *ngIf="expandedElement !== item.id">
                                        <button mat-icon-button color="primary" (click)="toggleTable(item)">
                                            <mat-icon>keyboard_arrow_down</mat-icon>
                                        </button>
                                    </ng-container>
                                    <ng-container *ngIf="expandedElement ===item.id">
                                        <button mat-icon-button color="primary" (click)="toggleTable(item)">
                                            <mat-icon>keyboard_arrow_up</mat-icon>
                                        </button>
                                    </ng-container>
                                </td>
                            </tr>

                            <tr *ngIf="expandedElement === item.id">
                                <td colspan="14">
                                    <div>
                                        <table class="branch-table">
                                            <thead>
                                                <tr>
                                                    <th>Label No</th>
                                                    <th>Label Description</th>
                                                    <th>Item/Service Name</th>
                                                    <th>HSN/SAC No</th>
                                                    <th>Unit</th>
                                                    <th>Description</th>
                                                    <th>Quantity</th>
                                                    <th>Unit Price</th>
                                                    <th>Price</th>
                                                    <th>Start Date</th>
                                                    <th>Requisition Delivery Date</th>
                                                    <th>Expected Delivery Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <ng-container *ngFor="let product of sku_data">
                                                    <tr *ngFor="let detail of product.po_archive_details; let first = first"
                                                        style="border: 1px solid black;">
                                                        <td>{{ detail?.level_no??'' }}</td>
                                                        <td>{{ detail?.level_desc??'' }}</td>
                                                        <td>{{ detail?.item_service_type === 'SKU' ?
                                                            detail?.stock_keeping?.sku_name :
                                                            detail?.service?.service_name }}</td>
                                                        <td>{{ detail?.hsn_no??'' }}</td>
                                                        <td>{{ detail?.unit?.unit_name??'' }}</td>
                                                        <td>{{ detail?.description??'' }}</td>
                                                        <td>{{ detail?.qty??'' }}</td>
                                                        <td>{{ detail?.unit_price??'' }}</td>
                                                        <td>{{ detail?.price??'' }}</td>
                                                        <td>{{ detail?.start_date??'' }}</td>
                                                        <td>{{ detail?.end_date??'' }}</td>
                                                         <td>{{detail?.expected_delivery_date}}</td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <ng-template #noDataContent>
        <div class="text-center">
            <p>No Purchase Order Archive data available</p>
        </div>
    </ng-template>
</div>